module.exports = __webpack_public_path__ + "static/bg-landing-ve-tablet-46524a204a02f5b780964582569d7bba.svg";